import { useEffect, useState, useRef } from "react";
import {
  DataGrid,
  GridToolbar,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import OnHoldService from "../../services/OnHoldService";
import UIWrapper from "../../components/UIWrapper";
import { CSVLink } from "react-csv";
import {
  Typography,
  Button,
  Modal,
  Box,
  Tab,
  Tabs,
  Stack,
  Tooltip,
  Divider,
} from "../../mui";
import PreAcsBulkEdit from "./OnHoldBulkEdit";
import { snackbarActions } from "../../Store/snackbar";
import EditOnHoldSample from "./EditOnHoldSample";
import { useDispatch } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
    </GridToolbarContainer>
  );
}

const onHoldColumns = [
  // { field: "id", headerName: "ID", width: 90, hide: true },
  {
    field: "client",
    headerName: "Client",
    minWidth: 100,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "project",
    headerName: "Project",
    minWidth: 150,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "inventory_code",
    headerName: "Inventory Code",
    minWidth: 180,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "tracking_number",
    headerName: "Tracking Number",
    minWidth: 180,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "carrier",
    headerName: "Carrier",
    minWidth: 100,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "storage_location",
    headerName: "Storage Location",
    minWidth: 150,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value && params.value !== 0) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "temperature",
    headerName: "Temperature",
    minWidth: 100,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value && params.value !== 0) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "tube_type",
    headerName: "Tube Type",
    minWidth: 100,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value && params.value !== 0) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "date_disposition",
    headerName: "Date Disposition",
    minWidth: 150,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "date_received",
    headerName: "Date Received",
    minWidth: 150,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "created_on",
    headerName: "Created On",
    minWidth: 180,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "created_by",
    headerName: "Created By",
    minWidth: 200,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "status",
    headerName: "Status",
    minWidth: 100,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value && params.value !== 0) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "on_hold_reason",
    headerName: "On-Hold Reason",
    minWidth: 100,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "updated_by",
    headerName: "Updated By",
    minWidth: 200,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "comments",
    headerName: "Comment",
    minWidth: 100,
    flex: 1,
    editable: false,
    valueGetter: (params) => {
      // if (!params.value) {
      //   return "None/Null";
      // }
      // return params.value;
      return params ?? "None/Null";
    },
  },
  {
    field: "Edit",
    minWidth: 60,
    flex: 1,
    renderCell: () => (
      <Tooltip title="Edit Aliquot Values" style={{ cursor: "pointer" }}>
        <EditIcon color={"primary"}></EditIcon>
      </Tooltip>
    ),
    editable: false,
  },
];

const OnHoldQueue = () => {
  const [tableData, setTableData] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const dispatch = useDispatch();
  const csvLink = useRef();
  const [fileName, setFileName] = useState("");
  const [originalData, setOriginalData] = useState({});
  // **************************************************************
  const [value, setValue] = useState("in_progress");

  const changeHandler = (event) => {
    setOpenUploadModal(true);
  };

  const handleUploadClose = () => {
    setOpenUploadModal(false);
  };

  const handleAcsEdit = (params) => {
    if (params.field === "Edit") {
      setOriginalData(params.row);
      setOpenEditModal(true);
    }
  };

  const downloadTemplate = () => {
    OnHoldService.downloadTemplate()
      .then((resp) => {
        const url = resp.data.presigned_url;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "template");
        document.body.appendChild(link);
        link.click();
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: "success",
            snackbarMessage: "Successfully downloaded the template file",
          })
        );
      })
      .catch((err) => {
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: "error",
            snackbarMessage:
              typeof err?.response?.data?.detail === "string"
                ? err.response.data.detail
                : "Something went wrong.",
          })
        );
      });
    return;
  };

  useEffect(() => {
    if (exportData && csvLink.current && csvLink.current.link) {
      setTimeout(() => {
        csvLink.current.link.click();
        setExportData([]);
      });
    }
  }, [exportData]);

  const handleOnHoldSamplesExport = async () => {
    await OnHoldService.exportOnHoldSamples()
      .then((resp) => {
        let currentTimestamp = Date.now();
        let date = new Intl.DateTimeFormat("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }).format(currentTimestamp);
        date = date.replace(/[^a-zA-Z0-9- ]/g, "_");
        date = date.replace(/\s/g, "");
        date = date.slice(0, -2);
        setFileName("on_hold_sample_export_" + date + ".csv");
        setExportData(resp.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChangeTabs = (event, newValue) => {
    setValue(newValue);
    getSample(newValue);
  };

  const getSample = async (status) => {
    setDataLoading(true);
    await OnHoldService.getOnHoldSamplesByStatus(status)
      .then((resp) => {
        setTableData(resp.data);
        setDataLoading(false);
      })

      .catch((err) => {
        console.log(err);
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: "error",
            snackbarMessage:
              typeof err?.response?.data?.detail === "string"
                ? err.response.data.detail
                : "Something went wrong.",
          })
        );
      });
  };

  useEffect(() => {
    getSample(value);
    return;
  }, [refresh]);

  useEffect(() => {
    if (selectedFile) {
      const data = new FormData();
      data.append("file", selectedFile);
      OnHoldService.bulkEditOnHoldSamples(data)
        .then((resp) => {
          // setUploadData(resp.data);
          dispatch(
            snackbarActions.showNotification({
              snackbarOpen: true,
              snackbarType: "success",
              snackbarMessage: resp.data,
            })
          );
          setSelectedFile(null);
          setRefresh((prev) => !prev);
        })
        .catch((err) => {
          dispatch(
            snackbarActions.showNotification({
              snackbarOpen: true,
              snackbarType: "error",
              snackbarMessage:
                typeof err?.response?.data?.detail === "string"
                  ? err.response.data.detail
                  : "Something went wrong.",
            })
          );
          setSelectedFile(null);
        });
      return;
    }
  }, [selectedFile]);

  return (
    <UIWrapper title="Samples On-Hold" paper>
      <Box>
        <Tabs
          value={value}
          onChange={handleChangeTabs}
          textColor="primary"
          indicatorColor="primary"
          aria-label="Samples On-Hold"
        >
          <Tab value="in_progress" label="In Progress" />
          <Tab value="completed" label="Completed" />
        </Tabs>
        <Divider style={{ width: "100%" }}></Divider>

        {/*  In Progress Items */}
        {(value === "in_progress" || value === "completed") && (
          <Stack
            sx={{
              marginTop: "10px",
            }}
          >
            <Box
              sx={{
                width: "100%",
                marginTop: "20px",
              }}
            >
              <Typography sx={{ mb: 1, fontSize: 15, fontWeight: "800" }}>
                Total Number of On-Hold Samples: {tableData.length}
              </Typography>
              <Box
                height="375px"
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
              >
                <DataGrid
                  rows={tableData}
                  columns={onHoldColumns}
                  loading={dataLoading}
                  density="compact"
                  disableSelectionOnClick
                  slots={{
                    toolbar: CustomToolbar,
                  }}
                  onCellClick={handleAcsEdit}
                  sx={{
                    "& .MuiDataGrid-columnHeaderTitle": {
                      fontWeight: "bold",
                    },
                  }}
                />
              </Box>
            </Box>

            {tableData && tableData.length !== 0 && (
              <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "15px" }}>
                <Button
                  style={{ width: "100px" }}
                  type="submit"
                  variant="contained"
                  onClick={handleOnHoldSamplesExport}
                >
                  Export
                </Button>
                <Button
                  style={{ width: "250px" }}
                  type="submit"
                  variant="contained"
                  onClick={changeHandler}
                >
                  Bulk Update On-Hold Queue
                </Button>
              </div>
            )}

            {exportData.length ? (
              <CSVLink
                data={exportData}
                filename={fileName}
                className="hidden"
                ref={csvLink}
                target="_blank"
              />
            ) : null}

            <Modal
              open={openUploadModal}
              onClose={handleUploadClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Stack>
                <PreAcsBulkEdit
                  files={selectedFile}
                  setFiles={setSelectedFile}
                  setOpen={setOpenUploadModal}
                  downloadTemplate={downloadTemplate}
                  accept={["csv", "xlsx"]}
                />
              </Stack>
            </Modal>

            {openEditModal ? (
              <EditOnHoldSample
                openServiceModal={openEditModal}
                setOpenServiceModal={setOpenEditModal}
                recordForEdit={originalData}
                setRefresh={setRefresh}
              />
            ) : null}
          </Stack>
        )}
      </Box>
    </UIWrapper>

    // <UIWrapper title="Samples On-Hold" paper>

    // </UIWrapper>
  );
};

export default OnHoldQueue;
